import axios from 'axios';
import { auth } from './firebase';

const superAdminApi = axios.create({
  baseURL: process.env.REACT_APP_SUPERADMIN_API_BASE_URL,
  withCredentials: true,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Enhanced request interceptor
superAdminApi.interceptors.request.use(
  async (config) => {
    console.log(`[SuperAdmin API Request] ${config.method?.toUpperCase()} ${config.url}`);
    
    const user = auth.currentUser;
    if (user) {
      try {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
        console.log('[SuperAdmin API Request] Token added to request');
      } catch (e) {
        console.error('[SuperAdmin API Request] Could not get ID token:', e);
      }
    }
    
    return config;
  },
  (error) => {
    console.error('[SuperAdmin API Request] Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Enhanced response interceptor
superAdminApi.interceptors.response.use(
  (response) => {
    console.log(`[SuperAdmin API Response] ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('[SuperAdmin API Response] Response error:', error);
    
    if (error.response) {
      console.error('[SuperAdmin API Response] Status:', error.response.status);
      console.error('[SuperAdmin API Response] Data:', error.response.data);
    } else if (error.request) {
      console.error('[SuperAdmin API Response] No response received:', error.request);
    } else {
      console.error('[SuperAdmin API Response] Request setup error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Authentication
export async function registerSuperAdmin(email, password, name) {
  const res = await superAdminApi.post('/register', { email, password, name });
  return res.data;
}

export async function loginSuperAdmin(email, password) {
  const res = await superAdminApi.post('/login', { email, password });
  return res.data;
}

// Profile Management
export async function getSuperAdminProfile() {
  const res = await superAdminApi.get('/profile');
  return res.data;
}

export async function updateSuperAdminProfile(profileData) {
  const res = await superAdminApi.put('/profile', profileData);
  return res.data;
}

// Restaurant Management
export async function getAllRestaurants(params = {}) {
  const res = await superAdminApi.get('/restaurants', { params });
  return res.data;
}

export async function getRestaurantDetails(restaurantId) {
  const res = await superAdminApi.get(`/restaurants/${restaurantId}`);
  return res.data;
}

export async function updateRestaurantStatus(restaurantId, status) {
  const res = await superAdminApi.put(`/restaurants/${restaurantId}/status`, { status });
  return res.data;
}

export async function updateRoomFeature(restaurantId, enabled) {
  const res = await superAdminApi.put(`/restaurants/${restaurantId}/room-feature`, { enabled });
  return res.data;
}

export async function updateStoreInventoryFeature(restaurantId, enabled) {
  const res = await superAdminApi.put(`/restaurants/${restaurantId}/store-inventory-feature`, { enabled });
  return res.data;
}
export async function updatemobileFeature(restaurantId, enabled) {
  const res = await superAdminApi.put(`/restaurants/${restaurantId}/mobile-feature`, { enabled });
  return res.data;
}

// Platform Analytics
export async function getPlatformOverview(params = {}) {
  const res = await superAdminApi.get('/analytics/overview', { params });
  return res.data;
}

export async function getDetailedAnalytics(params) {
  const res = await superAdminApi.get('/analytics/detailed', { params });
  return res.data;
}

export async function generateReport(data) {
  const res = await superAdminApi.post('/reports/generate', data, {
    responseType: 'blob', // Important to handle the file download
  });
  return res;
}





